import { SLATE_TEXT_FORMATS } from './const';

export const convertStringWithLineBreaksToParagraphs = (str) => {
  return str.split('\n').map((t) => ({
    type: SLATE_TEXT_FORMATS.PARAGRAPH,
    children: [
      {
        text: t,
      },
    ],
  }));
};

export const createDivider = (isLong = false) => {
  return [
    {
      type: SLATE_TEXT_FORMATS.PARAGRAPH,
      children: [{ text: isLong ? '——————————' : '———', bold: isLong }],
    },
  ];
};


export const createLineBreak = () => {
  return [
    {
      type: SLATE_TEXT_FORMATS.PARAGRAPH,
      children: [{ text: '' }],
    },
  ];
};
